<template>
  <div class="goods_index">
    <div class="shop_top">
      <shop-top :subnav_show="false" :change_color="true"></shop-top>
    </div>

    <div class="goods_where width_center_1200">
      <el-tabs v-model="tabsData.current" @tab-click="handleTab">
        <el-tab-pane
          v-for="(item, index) in tabsData.list"
          :key="index"
          :label="item.hdname"
          :name="item.hdno"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div v-loading="loading"  class="width_center_1200">
      <div v-if="goodsList.length" class="goods_list">
        <ul>
          <li v-for="item in goodsList" :key="item.id">
            <goods-card :item="item"></goods-card>
          </li>
        </ul>
        <div class="clear"></div>
      </div>

      <div v-if="noList" class="home_empty_list">
        <i class="font iconfont">&#xe600;</i>
        {{ lang.no_data }}
      </div>
    </div>

    <merchant-promise></merchant-promise>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import MerchantPromise from '@/components/MerchantPromise/index'
import GoodsCard from '@/components/ShopGoods/index'
import { getactivitydatil, getactivityproduct } from '@/api/product.js'
export default {
  components: {
    ShopTop,
    ShopFoot,
    MerchantPromise,
    GoodsCard
  },
  data() {
    return {
      tabsData: {
        list: [],
        current: ''
      },
      goodsList: [],
      goodsParams: {
        hdno: '',
        keyword: ''
      },
      noList: false
    }
  },
  computed: {
    lang() {
      return this.$t('goods')
    }
  },
  async created() {
    this.loading = true
    this.getGoodsType()
  },
  methods: {
    getGoodsType() {
      getactivitydatil().then(({ data }) => {
        this.tabsData.list = data
        if (data.length) {
          this.tabsData.current = data[0].hdno
          this.goodsParams.hdno = data[0].hdno
        }
        this.getList()
      })
    },
    getList() {
      getactivityproduct(this.goodsParams).then(({ data }) => {
        this.loading = false
        if (data.length === 0) {
          this.noList = true
        }
        this.goodsList = data.map((item) => {
          return {
            ...item,
            title: item.productname,
            thumbnailsImage: item.thumbnailsImage,
            canSaleCount: item.canSaleCount,
            productno: item.productno
          }
        })
      })
    },
    handleTab(val) {
      this.goodsParams.hdno = val.name
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.goods_where {
  background: #fff;
  margin: 20px auto;
  /deep/ .el-tabs__header {
    margin: 0;
  }
  /deep/ .el-tabs__nav-wrap::after {
    display: none;
  }
  /deep/ .el-tabs__item.is-active {
    color: #4f4f4f;
  }
  /deep/ .el-tabs__active-bar {
    background-color: #ec9221;
  }
  /deep/ .el-tabs__item:hover {
    color: #ec9221;
  }
  /deep/ .el-tabs__item {
    text-align: center;
    min-width: 109px;
    height: 46px;
    line-height: 46px;
    color: #4f4f4f;
    padding: 0;
    font-size: 12px;
  }
}
.goods_list {
  margin-bottom: 100px;
  min-height: 400px;
  width: 110%;
  li {
    float: left;
    box-sizing: border-box;
    margin-right: 16px;
    margin-bottom: 16px;
    width: 288px;
    height: 110px;
  }
}
</style>